<template>
  <div class="hp-editor">
    <div id="summernote"></div>
  </div>
</template>
<script>
export default {
  name: 'HPEditor',
  props: {
    content: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: '100%'
    },
    height: {
      type: [Number, String],
      default: 200
    }
  },
  data() {
    return {
      editorContent: '',
      initKey: 0
    }
  },
  watch: {
    content: {
      handler(val) {
        const vm = this
        if (vm.initKey <= 2 && vm.editorContent !== val) {
          // console.log('init')
          // 編輯器初始赋值
          $('#summernote').summernote('code', val)
          vm.initKey++
        }
        this.editorContent = val
      },
      deep: true,
      immediate: true
    },
    editorContent() {
      // console.log('editorContent: ', this.editorContent)
      this.$emit('update', this.editorContent)
    }
  },
  mounted() {
    const vm = this
    vm.$nextTick(() => {
      vm.summernoteInit().then(() => {
        // summernote發生改變時
          $('#summernote')
          .on('summernote.change', function (we, contents, $editable) {
            vm.summerNoteChange()
          })
      })
    })
  },
  destroyed() {
    $('#summernote').summernote('destroy')
  },
  methods: {
    summernoteInit() {
      const vm = this
      return new Promise((resolve) => {
        $('#summernote').summernote({
          lang: 'zh-TW',
          placeholder: '請輸入內容',
          width: vm.width,
          height: vm.height,
          htmlMode: true,
          textareaAutoSync: false,
          tabsize: 10,
          disableDragAndDrop: false,
          // disableResizeEditor: true, // disable resize bar
          toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['insert', ['link', 'unlink']],
            ['table', ['table']]
          ],
          callbacks: {
            onInit: (c) => {
              // $('.sn-checkbox-use-protocol').remove()
              $('.note-color-select.btn').remove()
              $('.note-holder-custom').remove()
              // $('.note-statusbar').hide()
              c.editable.html('') // 去掉<p><br></p>
            }
          }
        })
        resolve()
      })
    },
    summerNoteChange() {
      this.editorContent = $('#summernote').summernote('code')
    }
  }
}
</script>
<style
  scoped
  lang="css"
  src="../../../public/plugin/bootstrap/bootstrap.min.css"
></style>
<style lang="scss" scoped>
:deep(.note-editor) {
  /* line-height: 40px; */
  line-height: 1.8;

  // .note-placeholder {
  //   /* line-height: 1.8; */
  // }
  // display: flex;
  // flex-direction: column;
  // min-width: 0;
  // word-wrap: break-word;
  // background-color: #fff;
  // background-clip: border-box;
  // border-radius: 0.25rem;
  .note-toolbar {
    // background-color: rgba(0, 0, 0, 0.03);
    .note-btn {
      font-size: 12px;
      // background-color: #f7f7f7;
      // border-color: #f7f7f7;
    }
  }
  // &.note-editor.note-frame .note-status-output {
  //   height: auto;
  //   border-top: 0 solid transparent;
  // }
}

:deep(.sn-checkbox-use-protocol) {
  display: none;
}
</style>
